import { api } from './index';
import router from '@/routes';
import store from '@/store';
import XLSX from 'xlsx-js-style';
import route from 'vue-router';
import ExcelExport from 'export-xlsx';
// import { apiTest } from '@/api/sales/invoice';

const prefix = '/api/';

export async function getUpdateInfo(table_name, key_column, key_value) {
	return api.post(prefix + 'getUpdateInfo', { table_name: table_name, key_column: key_column, key_value: key_value });
}

export function apiUploadFile(file) {
	var formData = new FormData();
	formData.append('file', file);
	return api.post(prefix + 'uploadFile', formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
}

export function apiUploadImage(file) {
	const formData = new FormData();
	formData.append('file', file);
	return api.post(prefix + 'uploadImage', formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
}

export function apiDeletFilesByName(file_names) {
	return api.post(prefix + 'deleteFilesByName', objectToFormData({ file_names }));
}

export function apiUploadBinary(data) {
	//console.log(data.length);
	//var encodedBlob = btoa(data);
	var encodedBlob = _arrayBufferToBase64(data);
	//console.log(data.length);
	//console.log(encodedBlob.length);
	//console.log(encodedBlob);
	//var test = atob(encodedBlob);
	//console.log(test.length);
	// var formData = new FormData();
	// formData.append('content', data);
	// formData.append('filename', 'data.pdf');
	return api.post(prefix + 'uploadBinary', { encodedBlob: encodedBlob, filename: 'data.pdf' });
}

function _arrayBufferToBase64(buffer) {
	var binary = '';
	var bytes = new Uint8Array(buffer);
	var len = bytes.byteLength;
	for (var i = 0; i < len; i++) {
		binary += String.fromCharCode(bytes[i]);
	}
	return window.btoa(binary);
}

export function apiDownloadFile(filename, saveFilename) {
	api
		.get(prefix + 'downloadFile', {
			params: {
				filename: filename,
			},
			responseType: 'blob',
		})
		.then(response => {
			const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', saveFilename);
			document.body.appendChild(link);
			link.click();
		});
}

export async function apiGetReportTemplate(fileName, url) {
	const file = await getMrtFile(url);
	return createReport(file, fileName);
}

export async function apiGetBase64ReportTemplate(fileName, url) {
	const file = await getMrtFile(url);
	return createReportBase64(file, fileName);
}

export function createReport(file, fileName) {
	const report = new window.Stimulsoft.Report.StiReport();
	report.reportName = fileName;

	const blobData = isObject(file.data) ? JSON.stringify(file.data) : file.data;
	report.loadFile(window.URL.createObjectURL(new Blob([blobData], { type: file.headers['content-type'] })));
	report.dictionary.databases.clear();
	return report;
}

/**
 * base64 이미지를 표기하기 위해서는 file data를 string으로 한번 변환을 시켜줘야함.
 * @param file
 * @param fileName
 * @returns {Window.Stimulsoft.Report.StiReport}
 */
export function createReportBase64(file, fileName) {
	const report = new window.Stimulsoft.Report.StiReport();
	report.reportName = fileName;
	report.loadFile(window.URL.createObjectURL(new Blob([JSON.stringify(file.data)], { type: file.headers['content-type'] })));
	report.dictionary.databases.clear();
	return report;
}
export function createDataReport(file, fileName) {
	const report = new window.Stimulsoft.Report.StiReport();
	report.reportName = fileName;
	report.loadFile(window.URL.createObjectURL(new Blob([file.data], { type: file.headers['content-type'] })));
	return report;
}

export async function apiGetDataReportTemplate(fileName, url) {
	const file = await getMrtFile(url);
	return createDataReport(file, fileName);
}

export let Report = function(reportTemplate, data, fileName, type, base64 = false, mailModalOpen = false, toList, modalWidth = 0) {
	this.reportTemplate = reportTemplate;
	this.data = data;
	this.fileName = fileName;
	this.type = type;
	this.base64 = base64;
	this.mailModalOpen = mailModalOpen;
	this.toList = toList;
	this.modalWidth = modalWidth;
};

export async function getMrtFile(url) {
	return await api.get(url);
}

export function companyMrtUrl(fileName) {
	return prefix + 'file/' + getSessionCompanyId() + '/' + fileName;
}
export function reportMrtUrl(fileName) {
	return prefix + 'file/report/' + fileName;
}

export function createReportFile(report) {
	return new Promise((resolve, reject) => {
		try {
			let pdf = 1;
			report.exportDocumentAsync(function(pdfData) {
				// Convert pdfData to base64
				let base64Data = arrayBufferToBase64(pdfData);
				resolve(base64Data);
			}, pdf);
		} catch (error) {
			console.error('PDF 생성 중 오류 발생:', error);
			reject(error);
		}
	});
}

// Helper function: ArrayBuffer to Base64
function arrayBufferToBase64(buffer) {
	let binary = '';
	let bytes = new Uint8Array(buffer);
	let len = bytes.byteLength;
	for (let i = 0; i < len; i++) {
		binary += String.fromCharCode(bytes[i]);
	}
	return window.btoa(binary);
}

export function objectToFormData(obj) {
	let form_data = new FormData();
	for (const key in obj) {
		if (key === 'files') {
			const files = obj[key];
			for (let i = 0; i < files.length; i++) {
				form_data.append('files[' + i + ']', files[i]);
			}
		} else {
			form_data.append(key, obj[key]);
		}
	}
	return form_data;
}

export async function apiFileDownload(url, fileName) {
	const res = await api.get(url, { responseType: 'blob' });
	const contentDisposition = res.headers['content-type']; // 파일 이름
	if (contentDisposition) {
		const [fileNameMatch] = contentDisposition.split(';').filter(str => str.includes('filename'));
		if (fileNameMatch) [, fileName] = fileNameMatch.split('=');
	}
	const link = document.createElement('a');
	link.href = window.URL.createObjectURL(new Blob([res.data]));
	link.setAttribute('download', `${fileName}`);
	document.body.appendChild(link);
	link.click();
}

export async function apiPostFileDownload(url, data, fileName) {
	const res = await api.post(url, data, { responseType: 'blob' });
	const contentDisposition = res.headers['content-type']; // 파일 이름
	if (contentDisposition) {
		const [fileNameMatch] = contentDisposition.split(';').filter(str => str.includes('filename'));
		if (fileNameMatch) [, fileName] = fileNameMatch.split('=');
	}
	const link = document.createElement('a');
	link.href = window.URL.createObjectURL(new Blob([res.data]));
	link.setAttribute('download', `${fileName}`);
	document.body.appendChild(link);
	link.click();
}

export function objectToUrlParam(obj) {
	let str = '?';
	for (const key in obj) {
		if (str !== '?') {
			str += '&';
		}
		str += key + '=' + obj[key];
	}
	return str;
}

export const PrintType = {
	Normal: 0,
	List: 1,
};

export function objectCopy(obj) {
	return JSON.parse(JSON.stringify(obj));
}

export function getSessionCompanyId() {
	return router.app.$session.get('user').company_id;
}
export const exportFileType = {
	pdf: 'pdf',
	excel: 'excel',
};
// Only tracked beautyplus outputs are invalidated by the State-report mixin.
// Release loading immediately on cancellation, even while a callback is delayed.
export function startReportExport(state_scope_context) {
	let finished = false;
	const finish = () => {
		if (finished) return;
		finished = true;
		if (state_scope_context) delete state_scope_context.cancel;
		store.commit('setLoading', false);
	};
	store.commit('setLoading', true);
	if (state_scope_context) state_scope_context.cancel = finish;
	return {
		finish,
		isCurrent() {
			if (state_scope_context && !state_scope_context.valid) finish();
			return !finished;
		},
	};
}
export function exportFile(report, fileType, headerShowSkip = false) {
	const output = startReportExport(report.state_scope_context);
	if (!output.isCurrent()) return;
	const reportData = report.data;
	const reportTemplate = report.reportTemplate;
	let dataSet = new window.Stimulsoft.System.Data.DataSet();
	dataSet.readJson(reportData);
	reportTemplate.regData('', '', dataSet);

	reportTemplate.renderAsync(function() {
		if (!output.isCurrent()) return;
		let settings;
		let service;
		let extension;
		if (fileType === 'pdf') {
			settings = new window.Stimulsoft.Report.Export.StiPdfExportSettings();
			service = new window.Stimulsoft.Report.Export.StiPdfExportService();
			extension = 'pdf';
		} else if (fileType === 'excel') {
			settings = new window.Stimulsoft.Report.Export.StiExcel2007ExportSettings();
			// console.log(settings);
			settings.exportDataOnly = headerShowSkip;
			service = new window.Stimulsoft.Report.Export.StiExcel2007ExportService();
			extension = 'xlsx';
		}

		const stream = new window.Stimulsoft.System.IO.MemoryStream();
		service.exportToAsync(
			function() {
				if (!output.isCurrent()) return;
				try {
					const data = stream.toArray();
					const fileName = reportTemplate.reportName + '.' + extension;
					Object.saveAs(data, fileName, 'application/' + fileType);
				} finally {
					output.finish();
				}
			},
			reportTemplate,
			stream,
			settings,
		);
	});
}

export function exportExcel(target, fileName) {
	let wb;
	if (typeof target === 'string') {
		const el = document.getElementById(target);
		wb = XLSX.utils.table_to_book(el, { raw: true });
	} else {
		wb = target;
	}
	return XLSX.writeFile(wb, fileName + '.xlsx');
}

export function moveInvoice(invoiceNo, type) {
	if (type === 'i') router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: router.fullPath, invoice_no: invoiceNo } });
	else router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: router.fullPath, invoice_no: invoiceNo } });
}

export async function reportRender(data, fileName, url, state_scope_context) {
	const reportTemplate = await apiGetReportTemplate(fileName, url);
	const report = new Report(reportTemplate, data, fileName);
	if (state_scope_context && !state_scope_context.valid) return;
	report.state_scope_context = state_scope_context;
	store.commit('setReport', report);
}

export async function reportRenderHorizontally(data, fileName, url, state_scope_context) {
	const reportTemplate = await apiGetReportTemplate(fileName, url);
	const report = new Report(reportTemplate, data, fileName, PrintType.Normal, false, false, null, 70);
	if (state_scope_context && !state_scope_context.valid) return;
	report.state_scope_context = state_scope_context;
	store.commit('setReport', report);
}

export async function reportRenderBase64(data, fileName, url, state_scope_context) {
	const reportTemplate = await apiGetBase64ReportTemplate(fileName, url);
	const report = new Report(reportTemplate, data, fileName);
	if (state_scope_context && !state_scope_context.valid) return;
	report.state_scope_context = state_scope_context;
	store.commit('setReport', report);
}

export function invoicePageGo(invoiceNo, type, restriction_only = false) {
	const scope_query = restriction_only ? { restriction_only: 'true' } : {};
	let routeData;
	if (type === 'invoice') {
		routeData = router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: route.fullPath, invoice_no: invoiceNo, ...scope_query } });
		window.open(routeData.href, 'herp_invoice');
	} else {
		routeData = router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: route.fullPath, invoice_no: invoiceNo, ...scope_query } });
		window.open(routeData.href, 'herp_so');
	}
}

export function shipmentPageGo(shipmentNo) {
	let routeData = router.resolve({ name: 'shipmentDetail', params: { mode: 'detail' }, query: { backUri: route.fullPath, sh_no: shipmentNo } });
	window.open(routeData.href, 'herp_shipment');
}

export function purchasePageGo(po_no) {
	let routeData = router.resolve({ name: 'purchaseDetail', params: { mode: 'detail' }, query: { backUri: route.fullPath, po_no: po_no } });
	window.open(routeData.href, 'herp_purchase');
}

export function stimulsoftDirectPrint(mrt) {
	mrt.renderAsync(function() {
		mrt.print();
	});
}

export function listCheck(obj) {
	return obj.list && obj.list.length > 0;
}

export function indexCheck(indexList) {
	let a = true;
	indexList.forEach(function(value) {
		if (value !== 0) a = false;
	});
	return a;
}

export function isEmpty(obj) {
	return Object.keys(obj).length === 0;
}

export function itemNameColorFilter(name) {
	return name && name.lastIndexOf('-') >= 0 ? name.substring(0, name.lastIndexOf('-')) : name;
}

export function getExportExcelSettings(header, fileName, headerGroups) {
	return {
		// Table settings
		fileName: fileName,
		workSheets: [
			{
				startingRowNumber: 1,
				gapBetweenTwoTables: 2,
				tableSettings: {
					data: {
						headerDefinition: header,
						headerGroups: headerGroups,
					},
				},
			},
		],
	};
}

export function exportDataExcel(data, header, fileName, headerGroups) {
	const setting = getExportExcelSettings(header, fileName, headerGroups);

	const excelExport = new ExcelExport();
	excelExport.downloadExcel(setting, [{ data: data }]);
}

export function excelComplicated(data, defaultStyle, defaultHeight) {
	/* 
		data: 이차원 배열
		이차원 배열의 각 요소: { t: type, v: value, rs: rowspan, cs: colspan, s: {..}, height: '{hpx: ..}', width: '{wch: ..}' }
	*/
	const sheet = {};
	const merge_list = [];
	const occupied = []; // { r: row, c: column }
	const wsrows = [];
	const wscols = [];
	data.forEach((row, index) => {
		let row_height = { hpx: defaultHeight || 16 };
		row.forEach((cell, jIndex) => {
			let col_width = null;
			if (wscols.length > jIndex) {
				col_width = wscols[jIndex];
			} else {
				col_width = { wch: 10 };
				wscols.push(col_width);
			}

			let colIdx = 0;
			let isOccupied = true;
			const occupied_cells = occupied.filter(oc => oc.r === index);
			while (isOccupied) {
				isOccupied = occupied_cells.some(oc => oc.c === colIdx);
				if (isOccupied) colIdx++;
			}
			const cell_number = findCellNumber(index, colIdx);
			sheet[cell_number] = { t: cell.t, v: cell.v };
			if (cell.s) sheet[cell_number].s = cell.s;

			// set Default-Style
			if (defaultStyle && typeof defaultStyle === 'object') {
				const recursiveFunc = function(def, target) {
					for (const prop in def) {
						if (typeof def[prop] === 'object') {
							if (!target[prop]) target[prop] = {};
							recursiveFunc(def[prop], target[prop]);
						} else {
							if (!target[prop]) target[prop] = def[prop];
						}
					}
				};
				if (!sheet[cell_number].s) sheet[cell_number].s = {};
				recursiveFunc(defaultStyle, sheet[cell_number].s);
			}

			const rs = (cell.rs || 0) < 1 ? 1 : cell.rs;
			const cs = (cell.cs || 0) < 1 ? 1 : cell.cs;

			// merge_list add
			if (rs > 1 || cs > 1) merge_list.push({ s: { r: index, c: colIdx }, e: { r: index + rs - 1, c: colIdx + cs - 1 } });

			// occupied add
			for (let i = 0; i < rs; i++) {
				for (let j = 0; j < cs; j++) {
					occupied.push({ r: index + i, c: colIdx + j });

					if (cell.s && cell.s.border && (i > 0 || j > 0)) {
						const border = {};
						if (cell.s.border.top && i === 0) border.top = cell.s.border.top;
						if (cell.s.border.bottom && i === rs - 1) border.bottom = cell.s.border.bottom;
						if (cell.s.border.left && j === 0) border.left = cell.s.border.left;
						if (cell.s.border.right && j === cs - 1) border.right = cell.s.border.right;

						sheet[findCellNumber(index + i, colIdx + j)] = { t: 's', v: '', s: { border } };
					}
				}
			}

			// row_height + col_width
			if (cell.height && typeof cell.height.hpx === 'number') row_height.hpx = cell.height.hpx;
			if (cell.width && typeof cell.width.wch === 'number') col_width.wch = cell.width.wch;
		});
		wsrows.push(row_height);
	});

	const maxRowNum = occupied.reduce((prev, curr) => (prev < curr.r ? curr.r : prev), 0);
	const maxColNum = occupied.reduce((prev, curr) => (prev < curr.c ? curr.c : prev), 0);
	sheet['!ref'] = 'A1:' + findCellNumber(maxRowNum, maxColNum);
	sheet['!merges'] = merge_list;
	sheet['!cols'] = wscols;
	sheet['!rows'] = wsrows;

	return sheet;
}

function findCellNumber(rowIdx, colIdx) {
	const charCodeA = 'A'.charCodeAt(0);
	const charCodeZ = 'Z'.charCodeAt(0);
	const diff = charCodeZ - charCodeA + 1; // 26

	let q = colIdx + 1;
	let result = '';
	while (q > 0) {
		let remainder = q % diff;
		q = parseInt(q / diff);
		if (remainder === 0) {
			q -= 1;
			remainder += diff;
		}
		result = String.fromCharCode(charCodeA - 1 + remainder) + result;
	}

	return result + (rowIdx + 1);
}

export function xlsxBorder(top = 0, right = 0, bottom = 0, left = 0) {
	const borderStyle = function(i) {
		if (i === 1) return { style: 'thick' };
		else if (i === -1) return { style: 'thin' };
		else if (i === -2) return { style: 'dotted' };
		else return null;
	};

	const border = { top: borderStyle(top), right: borderStyle(right), bottom: borderStyle(bottom), left: borderStyle(left) };
	for (const prop in border) {
		if (!border[prop]) delete border[prop];
	}

	return border;
}

export const accounting_format = '_-"$"* #,##0.00_-;\\-"$"* #,##0.00_-;_-"$"* "-"??_-;_-@_-';
export const accounting_format_no_decimal_places = '_-"$"* #,##0_-;\\-"$"* #,##0_-;_-"$"* "-"??_-;_-@_-';

export function beep() {
	var snd = new Audio(
		'data:audio/wav;base64,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',
	);

	snd.play();
}
// 함수의 변수의 값이 string인지 object인지 모르지만 object여부 확인
export function isObject(obj) {
	return obj !== null && typeof obj === 'object';
}

const isFalsyValue = value => {
	if (value) return false;
	// Number, Boolean 타입은 기본값을 파라미터로 넘김.
	if (typeof value === 'number') return false;
	if (typeof value === 'boolean') return false;
	return true;
};

export function serialize(params) {
	const urlParams = new URLSearchParams();

	for (const key in params) {
		const value = params[key];
		if (isFalsyValue(value)) continue;
		if (Array.isArray(value)) {
			value.forEach(val => urlParams.append(key, val));
		} else {
			urlParams.append(key, value);
		}
	}
	return urlParams;
}
